export default __webpack_public_path__ + "right-bg4ac442d.png";